import React, { useEffect, useMemo, useState } from 'react';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import TextField from '@mui/material/TextField';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import DangerousIcon from '@mui/icons-material/Dangerous';
import FileDownloadDoneIcon from '@mui/icons-material/FileDownloadDone';
import RemoveIcon from '@mui/icons-material/Remove';
import DoneIcon from '@mui/icons-material/Done';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import './AuditoriaDetalleDataGrid.css';
import InputLabel from '@mui/material/InputLabel';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Height } from '@mui/icons-material';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import moment from 'moment';

export default function AuditoriaDetalleDataGrid({ rows, tabla, claveSecundaria, digitoValido }) {

    function createData(campo, valorAntiguo, valorNuevo) {
        return { campo, valorAntiguo, valorNuevo };
    }
    const [rowsAux, setRowsAux] = useState(rows);
    const initialColumns = [
        { field: 'campo', headerName: 'Campo', flex: 0.7 },
        {
            field: 'valorAntiguo', headerName: 'Valor Antiguo', flex: 0.7,
            renderCell: ({ row }) => {
                const rawValue = row.valorAntiguo;

                let value = rawValue;

                if (rawValue === true) {
                    value = 'Si';
                } else if (rawValue === false) {
                    value = 'No';
                } else if (moment(rawValue).isValid() && isNaN(rawValue)) {
                    value = moment.utc(rawValue).format('DD/MM/YYYY HH:mm:ss');
                }

                return <p>{value}</p>;
            }
        },
        {
            field: 'valorNuevo', headerName: 'Valor Nuevo', flex: 0.7,
            renderCell: ({ row }) => {
                const rawValue = row.valorNuevo;

                let value = rawValue;
                if (rawValue === true) {
                    value = 'Si';
                } else if (rawValue === false) {
                    value = 'No';
                } else if (moment(rawValue).isValid() && isNaN(rawValue)) {
                    value = moment.utc(rawValue).format('DD/MM/YYYY HH:mm:ss');
                }

                return <p>{value}</p>;
            }
        },
        {
            headerName: 'Estado', align: 'center',
            renderCell: (params) => {
                const row = params.row;
                const valorAntiguo = (row.valorAntiguo != undefined) ? row.valorAntiguo.toString() : "";
                const valorNuevo = (row.valorNuevo != undefined) ? row.valorNuevo.toString() : "";

                if ((valorAntiguo == '' || valorAntiguo == undefined) && (valorNuevo != '' && valorNuevo != undefined))
                    return <AddIcon style={{ color: 'green' }} />
                else if ((valorAntiguo != '' && valorAntiguo != undefined) && (valorNuevo == '' || valorNuevo == undefined))
                    return <RemoveIcon style={{ color: 'red' }} />
                else if ((valorAntiguo != valorNuevo))
                    return <EditIcon style={{ color: 'black' }} />
                else
                    return <DoneIcon style={{ color: 'green' }} />

            },
            flex: 0.7
        }
    ];

    // Filtro campos que sean navigation
    useEffect(() => {
        setRowsAux(rows.filter((row) => !row.campo.includes('Navigation', row.campo.length - 10)));
    }, [])

    const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), []);

    return (
        <>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography style={{ fontWeight: 'bold', color: 'black', width: '100%' }}>Tabla: {tabla} - Id: {claveSecundaria}
                        <span style={{ float: 'right' }}>Registro Válido:
                            {(digitoValido) ? <FileDownloadDoneIcon className='doneIcon' /> : <DangerousIcon className='dangerousIcon' />}
                        </span>
                    </Typography>
                    <Typography style={{ fontWeight: 'bold', color: 'black', float: 'right' }}>
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <div>
                        <DataGridGenerico
                            columns={columns}
                            totalCount={rows.length}
                            rows={rowsAux}
                            toolbar={false}
                        />
                    </div>
                </AccordionDetails>
                <div style={{ marginLeft: '10px', fontStyle: 'italic' }}>
                    <AddIcon style={{ color: 'green' }} /> Se agrega un campo
                    <RemoveIcon style={{ color: 'red' }} /> Se elimina un campo
                    <EditIcon style={{ color: 'black' }} /> Se modifica un campo
                    <DoneIcon style={{ color: 'green' }} /> Sin cambios
                </div>
            </Accordion>

        </>
    );
};

